import { render } from "./TestManagement.vue?vue&type=template&id=0d7b5bea"
import script from "./TestManagement.vue?vue&type=script&lang=js"
export * from "./TestManagement.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__